declare var $: any;
declare var WebxpayTokenizeInit: any;
import { get } from 'scriptjs';

import { Component, OnInit } from '@angular/core';
import { CardService } from 'src/app/services/card.service';
import { environment } from './../../../../environments/environment';
import { MatSnackBar, MatDialog } from '@angular/material';
const apiURL = environment.apiURL;

@Component({
  selector: 'app-add-credit-card',
  templateUrl: './add-credit-card.component.html',
  styleUrls: ['./add-credit-card.component.css']
})

export class AddCreditCardComponent implements OnInit {

  public cardNumber = "";
  public cardHolderName = " ";
  public expiryDate = " ";
  public cvc = " ";
  sessionID: string;

  constructor(private cardService: CardService, private snackBar: MatSnackBar, private dialog: MatDialog) { }

  ngOnInit() {

    const cardServices = CardService;
    const scope = this;
    // webxpay codes
    // init webxpay
    get("https://cbcmpgs.gateway.mastercard.com/form/version/63/merchant/WEBXPATOKLKR/session.js", () => {
      WebxpayTokenizeInit({
        card: {
          number: "#card-number",
          securityCode: "#security-code",
          expiryMonth: "#expiry-month",
          expiryYear: "#expiry-year",
          nameOnCard: "#cardholder-name",
        },
        ready: afterInit,
      });

      function afterInit(GenerateSession) {
        // save card
        $('#save-card-button').click(function () {
          $('#save-card-button').attr('disabled', true);

          GenerateSession(
            function (session) {
              handleSuccess(session);
            },
            function (error) {
              handleErrors(error);
            }
          );
        });
      }

      // execute when hosted session successfully generated
      function handleSuccess(sessionId) {

        const data = new FormData();
        data.append('session', sessionId);

        scope.cardService.addCard(data).subscribe(result => {
          if (result.success) {
            const localUser = localStorage.getItem('user');
            const user = JSON.parse(localUser);
            user.cards = result.data;

            const userString = JSON.stringify(user);

            localStorage.setItem('user', userString);
            scope.cardService.setCards(user.cards);

            scope.dialog.closeAll();
            scope.snackBar.open('Card successfully added', 'Dismiss', {
              duration: 3000
            })
          }
        }, error => {
          $('#save-card-button').removeAttr('disabled');

          scope.snackBar.open(error.error.data, 'Dismiss', {
            duration: 6000
          })
        });
      }
      // execute when hosted session generation fail.
      function handleErrors(error) {
        $('#save-card-button').removeAttr('disabled');
        $('#save-card-button').html('Save');

        $('.err').html('');
        $('.general-error').html('');

        switch (error.type) {
          case 'fields_in_error': {
            if (error.details.cardNumber) {
              if (error.details.cardNumber == 'missing') {
                $('.card-number-error').html('Enter valid card number');
              }
              if (error.details.cardNumber == 'invalid') {
                $('.card-number-error').html('Invalid card number');
              }
            }
            if (error.details.expiryMonth) {
              if (error.details.expiryMonth == 'missing') {
                $('.exp-month-error').html('Enter expiration month');
              }
              if (error.details.expiryMonth == 'invalid') {
                $('.exp-month-error').html('Invalid expiration month');
              }
            }
            if (error.details.expiryYear) {
              if (error.details.expiryYear == 'missing') {
                $('.exp-year-error').html('Enter expiration year');
              }
              if (error.details.expiryYear == 'invalid') {
                $('.exp-year-error').html('Invalid expiration year');
              }
            }
            if (error.details.securityCode) {
              if (error.details.securityCode == 'missing') {
                $('.cvv-error').html('Enter CVV');
              }
              if (error.details.securityCode == 'invalid') {
                $('.cvv-error').html('Invalid CVV');
              }
            }
            console.error('missing card details', error.details);
            break;
          }
          case 'request_timeout': {
            $('.general-error').html('<span class="text-decoration-uppercase">' + error.details + '</span>')
            console.error('request time out', error.details);
            break;
          }
          case 'system_error': {
            if (error.details == 'cvv missing') {
              $('.general-error').html('Enter CVV details');
            } else {
              $('.general-error').html(error.details);
            }
            console.error('system error', error.details);
            break;
          }
        }
      }
    });
  }
}
